/**
 * Created by why on 2019/10/21.
 */
import axios from '@/libs/api.request'
export const quartzList = ({pageNum, pageSize}) => {
  return axios.request({
    url: '/quartz/selectAll',
    params: {
      pageNum,
      pageSize
    },
    method: 'get'
  })
}

export const addQuartz = (data) => {
  return axios.request({
    url: '/quartz/add',
    data: data,
    method: 'post'
  })
}

export const updateQuartz = (data) => {
  return axios.request({
    url: '/quartz/edit',
    data: data,
    method: 'post'
  })
}

export const deleteQuartz = (data) => {
  return axios.request({
    url: '/quartz/delByIds',
    data: data,
    method: 'post'
  })
}

export const pauseQuartz = (data) => {
  return axios.request({
    url: '/quartz/pause',
    data: data,
    method: 'post'
  })
}

export const resumeQuartz = (data) => {
  return axios.request({
    url: '/quartz/resume',
    data: data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/quartz-manage.js